export interface Campaign {
  campaignURN: string;
  isSelected: boolean;
  name: string;
}

interface SocialLinks {
  facebook?: string;
  instagram?: string;
  linkedin?: string;
  twitter?: string;
}

export interface CampaignBranding {
  accentColour: string;
  addressLine1: string;
  addressLine2: string;
  bodyCopy: string;
  bodyFont: string;
  callToActionText: string;
  campaignName: string;
  cancelAllSubscriptionsButtonText: string;
  city: string;
  companyName: string;
  confirmationBodyCopy: string;
  confirmationCancelButtonLabel: string;
  confirmationEmailBodyCopy: string;
  confirmationEmailTitleCopy: string;
  confirmationFooterText: string;
  confirmationRedirectMessage: string;
  confirmationTitleCopy: string;
  country: string;
  descriptionCopy: string;
  emailAddress?: string;
  emailInputLabel: string;
  error?: string;
  firstNameLabel: string;
  footerText: string;
  headerImageAddress: string;
  headerLinkAddress: string;
  helperText: string;
  isDoubleOptInEnabled: boolean;
  isFirstNameLastNameEnabled: boolean;
  isFooterTextEnabled: boolean;
  isPrivacyPolicyEnabled: boolean;
  isSubscriptionConfirmationEnabled: boolean;
  lastNameLabel: string;
  logoImageAddress: string;
  ogImageURL: string;
  orderedCampaigns: [Campaign];
  page?: string;
  phoneNumber: string;
  postcode: string;
  preferencesUpdatedCopy: string;
  privacyPolicyLinkText: string;
  privacyPolicyURL: string;
  propertyName: string;
  propertyPrivacyPolicyEnabled: boolean;
  propertyPrivacyPolicyLink: string;
  propertyPrivacyPolicyText: string;
  redirectMessageCopy: string;
  redirectURL: string;
  selectAllNewslettersButtonText: string;
  signupButtonLabel: string;
  signupFooterText: string;
  socialLinks: SocialLinks;
  socialNetworkLinkText: string;
  sponsoredContentLabel: string;
  subscribeEmailAddressError: string;
  subscribeGeneralError: string;
  titleCopy: string;
  titleFont: string;
  unsubscribeBodyCopy: string;
  unsubscribeCancelButtonLabel: string;
  unsubscribeLinkText: string;
  unsubscribeRedirectMessage: string;
  unsubscribeTitleCopy: string;
  unsubscribeURL: string;
  unsubscribedFromAllCopy: string;
  updatePreferencesButtonText: string;
  verificationBodyCopy: string;
  verificationCancelButtonLabel: string;
  verificationEmailBodyCopy: string;
  verificationEmailButtonText: string;
  verificationEmailTitleCopy: string;
  verificationRedirectMessage: string;
  verificationTitleCopy: string;
  customFieldsConfig?: SubscriptionFormCustomFieldsConfig;
  customFieldDefinitions?: CustomField[];
}

export interface PropertyBranding {
  accentColour: string;
  accessEmailSentHostedPageBodyCopy: string;
  accessEmailSentHostedPageTitleCopy: string;
  accessHostedPageBodyCopy: string;
  accessHostedPageButtonText: string;
  accessHostedPageTitleCopy: string;
  addressLine1: string;
  addressLine2: string;
  bodyCopy: string;
  bodyFont: string;
  callToActionText: string;
  campaignName: string;
  cancelAllSubscriptionsButtonText: string;
  city: string;
  companyName: string;
  confirmationBodyCopy: string;
  confirmationCancelButtonLabel: string;
  confirmationEmailBodyCopy: string;
  confirmationEmailTitleCopy: string;
  confirmationFooterText: string;
  confirmationRedirectMessage: string;
  confirmationTitleCopy: string;
  country: string;
  descriptionCopy: string;
  emailAddress?: string;
  emailInputLabel: string;
  error?: string;
  firstNameLabel: string;
  footerText: string;
  headerImageAddress: string;
  headerLinkAddress: string;
  helperText: string;
  isDoubleOptInEnabled: boolean;
  isFirstNameLastNameEnabled: boolean;
  isFooterTextEnabled: boolean;
  isPrivacyPolicyEnabled: boolean;
  isSubscriptionConfirmationEnabled: boolean;
  lastNameLabel: string;
  logoImageURL: string;
  ogImageURL: string;
  orderedCampaigns: [Campaign];
  page?: string;
  phoneNumber: string;
  postcode: string;
  preferencesUpdatedCopy: string;
  privacyPolicyLinkText: string;
  privacyPolicyURL: string;
  propertyName: string;
  propertyPrivacyPolicyEnabled: boolean;
  propertyPrivacyPolicyLink: string;
  propertyPrivacyPolicyText: string;
  redirectMessageCopy: string;
  redirectURL: string;
  selectAllNewslettersButtonText: string;
  signupButtonLabel: string;
  signupFooterText: string;
  socialLinks: SocialLinks;
  socialNetworkLinkText: string;
  sponsoredContentLabel: string;
  subscribeEmailAddressError: string;
  subscribeGeneralError: string;
  titleCopy: string;
  titleFont: string;
  unsubscribeBodyCopy: string;
  unsubscribeCancelButtonLabel: string;
  unsubscribeLinkText: string;
  unsubscribeRedirectMessage: string;
  unsubscribeTitleCopy: string;
  unsubscribeURL: string;
  unsubscribedFromAllCopy: string;
  updatePreferencesButtonText: string;
  verificationBodyCopy: string;
  verificationCancelButtonLabel: string;
  verificationEmailBodyCopy: string;
  verificationEmailButtonText: string;
  verificationEmailTitleCopy: string;
  verificationRedirectMessage: string;
  verificationTitleCopy: string;
  customFieldsConfig?: SubscriptionFormCustomFieldsConfig;
  customFieldDefinitions?: CustomField[];
}

export interface SubscriptionFormCustomField {
  dataName: string;
  displayLabel?: string;
  placeholder?: string;
  errorMessage?: string;
  isMandatory: boolean;
  order: number;
}

export interface SubscriptionFormCustomFieldsConfig {
  enabledFields: SubscriptionFormCustomField[];
  version: number;
}

export enum CustomFieldDataType {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  BOOLEAN = 'BOOLEAN',
  SINGLE_SELECT = 'SINGLE_SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  SET_STRING = 'SET_STRING', // Backend format for multi-select
  COUNTRY = 'COUNTRY',
}

export interface CustomField {
  dataName: string;
  displayName: string;
  dataType: CustomFieldDataType;
  constraint?: CustomFieldConstraint;
}

export interface CustomFieldConstraint {
  type: string;
  values?: string[];
}
